/**
 * Browser consent mode for persisting JWT / user data (localStorage, cross-origin cookie iframe).
 * Sent to data-hub-action as `data-hub-privacy-policy` on GET/POST and CORS iframe fetches.
 */

export const DATA_HUB_PRIVACY_POLICY_HEADER = 'data-hub-privacy-policy';

/**
 * @param {unknown} value
 * @returns {'all'|'necessary'|'none'}
 */
export function normalize_data_hub_privacy_policy_string(value) {
	if (value === null || value === undefined) {
		return 'all';
	}
	if (typeof value !== 'string') {
		return 'all';
	}
	const normalized = value.trim().toLowerCase();
	if (normalized === 'none') {
		return 'none';
	}
	if (normalized === 'necessary' || normalized === 'necesary') {
		return 'necessary';
	}
	if (normalized === 'all') {
		return 'all';
	}
	return 'all';
}

/**
 * @param {Object|null|undefined} data_hub_instance
 * @returns {boolean}
 */
export function data_hub_privacy_policy_allows_browser_storage(data_hub_instance) {
	const mode = normalize_data_hub_privacy_policy_string(data_hub_instance?.privacy_policy);
	return mode === 'all' || mode === 'necessary';
}

/**
 * Headers every browser → action request should include when a DataHub instance exists.
 * @param {Object|null|undefined} data_hub_instance
 * @returns {Record<string, string>}
 */
export function build_data_hub_action_privacy_headers(data_hub_instance) {
	const policy = normalize_data_hub_privacy_policy_string(data_hub_instance?.privacy_policy);
	return {
		[DATA_HUB_PRIVACY_POLICY_HEADER]: policy,
	};
}
